import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isEbillingEnabled } from '~/constants/featureFlag'
import { BillingEdit } from '~/pages/Billing/edit'

export const Route = createFileRoute('/_authenticated/billing/edit')({
  // ebilling 連携が無効な環境では請求編集ページにアクセスさせずホームへリダイレクトする
  beforeLoad: () => {
    if (!isEbillingEnabled) {
      // redirect() は throw して使うのが TanStack Router の作法
      throw redirect({ to: '/' })
    }
  },
  component: () => (
    <OrganizationAdmin thorwError>
      <BillingEdit />,
    </OrganizationAdmin>
  ),
})
